import * as Panel from "../../../src/Components/Panel/Panel.scss";
import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import * as react from "react";
import { classNames } from "../../Utils.js";
import { equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";


export class PanelStyle extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Default", "Primary", "Secondary", "Success", "Warning", "Error"];
    }
}

export function PanelStyle$reflection() {
    return union_type("Components.Panel.PanelStyle", [], PanelStyle, () => [[], [], [], [], [], []]);
}

function getPanel(style, heading, body, footer) {
    let headingHtml;
    if (heading == null) {
        headingHtml = react.createElement(react.Fragment, {});
    }
    else {
        const element = heading;
        headingHtml = react.createElement("div", {
            className: "panel__heading",
        }, element);
    }
    let footerHtml;
    if (footer == null) {
        footerHtml = react.createElement(react.Fragment, {});
    }
    else {
        const element_1 = footer;
        footerHtml = react.createElement("div", {
            className: "panel__footer",
        }, element_1);
    }
    const panelClasses = classNames(ofArray([["panel", true], ["panel--default", equals(style, new PanelStyle(0))], ["panel--primary", equals(style, new PanelStyle(1))], ["panel--secondary", equals(style, new PanelStyle(2))], ["panel--success", equals(style, new PanelStyle(3))], ["panel--warning", equals(style, new PanelStyle(4))], ["panel--error", equals(style, new PanelStyle(5))]]));
    const children_8 = [headingHtml, react.createElement("div", {
        className: "panel__body",
    }, body), footerHtml];
    return react.createElement("div", {
        className: panelClasses,
    }, ...children_8);
}

export function getDefault(heading, body, footer) {
    return getPanel(new PanelStyle(0), heading, body, footer);
}

export function primary(heading, body, footer) {
    return getPanel(new PanelStyle(1), heading, body, footer);
}

export function secondary(heading, body, footer) {
    return getPanel(new PanelStyle(2), heading, body, footer);
}

export function success(heading, body, footer) {
    return getPanel(new PanelStyle(3), heading, body, footer);
}

export function warning(heading, body, footer) {
    return getPanel(new PanelStyle(4), heading, body, footer);
}

export function error(heading, body, footer) {
    return getPanel(new PanelStyle(5), heading, body, footer);
}

